import React, { useMemo } from "react"
import styled, { useTheme } from "~/ui/styled"
import { ColumnFlex, CenterFlex, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { Message } from "~models"
import { useStores } from "~models"
import { AttachRedPacketData, RedpacketStatus } from "~proto"
import {
  PopupRoot,
  PopupImageBackground,
  PopupClose,
} from "../components/PopupShell"

const transferBg = require("~assets/images/chat/transfer_bg.png")

interface Props {
  message?: Message
  redpacketData?: AttachRedPacketData
  onClose: () => void
}

const ExclusiveRedPacketDetailPopup: React.FC<Props> = ({ message, redpacketData, onClose }) => {
  const theme = useTheme()
  const { userStore } = useStores()
  const receiver = redpacketData?.grap_info[0]
  const { attach = {} } = message
  const redpacketInfo = attach?.redpacket_info
  const { sender_id, sender_nickname, blessing_words, status } = redpacketData
  const isReceiver = receiver?.receiver_id === userStore.currentUser?.id
  const isSender = sender_id === userStore.currentUser?.id
  const StatusDesc = useMemo(() => {
    if (status === RedpacketStatus.EXPIRED) {
      if (isSender) {
        return "该红包已超过24小时对方未收款，已退还到余额"
      } else {
        return "该红包已超过24小时"
      }
    } else if (status === RedpacketStatus.REFUNDED) {
      if (isSender) {
        return "该红包已超过24小时对方未收款，已退还到余额"
      } else {
        return "该红包已超过24小时"
      }
    } else if (status === RedpacketStatus.FINISHED) {
      if (isSender) {
        return `${receiver.receiver_nickname}已领取您的红包`
      } else {
        if (redpacketData?.sender_nickname && redpacketData?.sender_nickname.includes("系统赔付")) {
          return "赔付完成"
        } else {
          return "已存入您的账户余额"
        }
      }
    }
    return "该红包还没被领取"
  }, [isReceiver, isSender, receiver])
  return (
    <PopupRoot width="100%">
      <PopupImageBackground src={transferBg} resizeMode="cover">
        <ColumnFlex width="100%" height="100%" alignItems="center">
          <CenterFlex
            width="60px"
            height="60px"
            padding="2px"
            mt="60px"
            borderRadius="30px"
            bg={theme.colors.text}
          >
            <Avatar avatar={receiver?.avatar} size={56} name={sender_nickname} />
          </CenterFlex>

          <Text mt="8px" fontSize={18} color={theme.colors.text} fontWeight="600">
            {sender_nickname || ""}的红包
          </Text>
          <CenterFlex height="auto" width="80%" padding="0 12px" mt="5px">
            <Text numberOfLines={2} fontSize={13} color={theme.colors.text}>
              {blessing_words || "恭喜发财，大吉大利"}
            </Text>
          </CenterFlex>

          <Text mt="15px" fontSize={40} color={theme.colors.error} fontWeight="600">
            ¥{redpacketInfo?.total_amount || "0"}
          </Text>
          <Text mt="5px" fontSize={10} color={theme.colors.secondary}>
            {StatusDesc}
          </Text>
        </ColumnFlex>
      </PopupImageBackground>
      <PopupClose onClose={onClose} />
    </PopupRoot>
  )
}

export default ExclusiveRedPacketDetailPopup
